exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-app {\n  height: 100vh;\n}\n.md-drawer {\n  width: 340px;\n  max-width: calc(100vw - 75px);\n  border-width: 1px;\n  border-style: solid;\n  border-color: #2C3030;\n  border-radius: 0;\n}\n@media only screen and (max-width: 599px) {\n.md-drawer {\n      height: 100%;\n      overflow: auto;\n}\n}\n.mobile__menu-icon {\n  display: none;\n}\n@media only screen and (max-width: 767px) {\n.mobile__menu-icon {\n      display: initial;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a7a1796","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/root/App.vue
// module id = DG9e
// module chunks = 1